module.exports = "../../app/cells/components/modals/pay_wall_modal/components/cta.erb";